var _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg404Img(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 279,
    height: 260,
    viewBox: "0 0 279 260",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M270.091 129.76C270.091 166.031 255.276 198.726 231.521 222.226C208.278 245.472 176.093 259.52 140.588 259.52C105.338 259.52 73.154 245.216 49.6542 222.226C25.899 198.726 11.084 166.031 11.084 129.76C11.084 57.9831 69.0671 0 140.588 0C212.108 0 270.091 58.2385 270.091 129.76Z",
    fill: "#EAEEF9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_804_54904)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256.347 55.3849V196.907C256.347 202.797 251.631 207.463 245.851 207.463H32.6807C26.9008 207.463 22.1094 202.72 22.1094 196.907V55.3849C22.1094 49.571 26.8247 44.8281 32.6807 44.8281H245.851C251.631 44.8281 256.347 49.571 256.347 55.3849Z",
    fill: "url(#paint0_linear_804_54904)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M256.347 55.3849V71.2201H22.1094V55.3849C22.1094 49.571 26.8247 44.8281 32.6807 44.8281H245.851C251.631 44.8281 256.347 49.571 256.347 55.3849Z",
    fill: "#D5DDEA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8631 61.9635C39.047 61.9635 40.8177 60.1826 40.8177 57.9857C40.8177 55.7887 39.047 54.0078 36.8631 54.0078C34.6789 54.0078 32.9082 55.7887 32.9082 57.9857C32.9082 60.1826 34.6789 61.9635 36.8631 61.9635Z",
    fill: "#989FB0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M49.7905 61.9635C51.9745 61.9635 53.7451 60.1826 53.7451 57.9857C53.7451 55.7887 51.9745 54.0078 49.7905 54.0078C47.6063 54.0078 45.8359 55.7887 45.8359 57.9857C45.8359 60.1826 47.6063 61.9635 49.7905 61.9635Z",
    fill: "#989FB0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M62.646 61.9635C64.8302 61.9635 66.6006 60.1826 66.6006 57.9857C66.6006 55.7887 64.8302 54.0078 62.646 54.0078C60.4621 54.0078 58.6914 55.7887 58.6914 57.9857C58.6914 60.1826 60.4621 61.9635 62.646 61.9635Z",
    fill: "#989FB0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M71.0078 167.609H207.443",
    stroke: "#D5DDEA",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M92.5312 182.219H185.922",
    stroke: "#D5DDEA",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M116.414 126.45V134.33H111.622V141.903H102.648V134.33H82.875V125.303L101.203 99.6758H111.698V126.527H116.414V126.45ZM102.648 110.156L91.2407 126.45H102.648V110.156Z",
    fill: "#21C4C1"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M138.921 142.746C129.338 142.746 120.896 134.332 120.896 120.715C120.896 107.098 129.262 98.6836 138.921 98.6836C148.579 98.6836 156.945 107.098 156.945 120.715C156.945 134.332 148.579 142.746 138.921 142.746ZM138.921 134.638C143.408 134.638 147.895 130.124 147.895 120.792C147.895 111.459 143.408 106.945 138.921 106.945C134.434 106.945 129.947 111.459 129.947 120.792C129.947 130.124 134.434 134.638 138.921 134.638Z",
    fill: "#21C4C1"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M195.656 126.45V134.33H190.865V141.903H181.89V134.33H162.117V125.303L180.445 99.6758H190.941V126.527H195.656V126.45ZM181.815 110.156L170.407 126.45H181.815V110.156Z",
    fill: "#21C4C1"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M245.987 238.716L195.037 187.805L206.718 176.125L257.627 227.076L245.987 238.716Z",
    fill: "#858B9B"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M263.7 256.627L224.632 217.558C221.37 214.296 221.37 208.979 224.632 205.716C227.894 202.454 233.212 202.454 236.474 205.716L275.542 244.785C278.804 248.047 278.804 253.365 275.542 256.627C272.28 259.888 266.962 259.888 263.7 256.627Z",
    fill: "#858B9B"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M260.921 259.124L210.655 208.857C209.487 207.689 209.487 205.796 210.655 204.588L223.503 191.739C224.672 190.571 226.565 190.571 227.773 191.739L278.04 242.005C279.207 243.174 279.207 245.067 278.04 246.275L265.192 259.124C263.981 260.291 262.088 260.291 260.921 259.124Z",
    fill: "#7F65ED"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M137.362 23.7539C84.0354 23.7539 40.8184 66.9712 40.8184 120.298C40.8184 173.585 84.0354 216.842 137.322 216.842C190.649 216.842 233.866 173.625 233.866 120.298C233.866 66.9712 190.649 23.7539 137.362 23.7539ZM137.362 198.959C94.5478 198.959 59.8693 163.717 59.8693 120.258C59.8693 76.799 94.5478 41.5966 137.362 41.5966C180.177 41.5966 214.855 76.8391 214.855 120.298C214.855 163.757 180.137 198.959 137.362 198.959Z",
    fill: "#7F65ED"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_804_54904",
    x: 0.109375,
    y: 33.8281,
    width: 278.237,
    height: 206.637,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_804_54904"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_804_54904",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_804_54904",
    x1: 139.152,
    y1: 41.0664,
    x2: 139.152,
    y2: 209.217,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#ECF0F5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg404Img);
export default __webpack_public_path__ + "static/media/404-img.8cddd94367525391888b85bb80ad3d8e.svg";
export { ForwardRef as ReactComponent };